import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import { createElement, useMemo, useState } from "react";
import { TbDotsVertical } from "react-icons/tb";

import { useTrackingActions } from "@/stores/use-tracking-table";
import { IPlanPassenger } from "@/types/tasks.types";

import { TrackingDetailClickActionNames, trackingDetailActions } from "./TrackingDetailActionsColumn";

function TrackingDetailActionHeader({
    allRows,
    selectedRowIds,
}: {
    allRows: IPlanPassenger<"api">[];
    selectedRowIds: GridRowSelectionModel;
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);
    const selectedRows = useMemo(
        () => allRows.filter((row) => selectedRowIds.includes(row.id)),
        [allRows, selectedRowIds]
    );
    const { updateShowBulkUnassignDialog } = useTrackingActions();

    const handleUnassign = () => {
        const ids = selectedRows.map((row) => row.id);
        if (!ids || !ids.length) return;
        updateShowBulkUnassignDialog({ totalPassengers: allRows.length, ids });
    };

    const clickActions: Partial<Record<TrackingDetailClickActionNames, { cb: () => void }>> = useMemo(
        () => ({
            [TrackingDetailClickActionNames.PASSENGER_UNASSIGN]: {
                cb: handleUnassign,
            },
        }),
        [handleUnassign]
    );

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className="flex items-center  justify-end  !mx-auto">
            {trackingDetailActions.length > 0 && (
                <>
                    <IconButton onClick={handleClick} size="small" className=" !w-[30px] grow-0 shrink-0 !h-[30px]">
                        <TbDotsVertical size={18} />
                    </IconButton>
                    <Menu
                        sx={{
                            ":root": {},
                        }}
                        classes={{
                            paper: "!min-w-[178.58px]",
                            list: "!min-w-[178.58px]",
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        onClick={handleClose}
                    >
                        {trackingDetailActions.map((action) => (
                            <MenuItem
                                disabled={!selectedRows.length}
                                key={action.label}
                                onClick={clickActions[action.onClick]?.cb}
                                sx={{}}
                            >
                                <ListItemIcon>{createElement(action.icon, { color: action.color })}</ListItemIcon>
                                <ListItemText>{action.label}</ListItemText>
                                <Typography variant="body2" sx={{ color: "text.secondary", paddingLeft: 3 }}>
                                    {selectedRows.length}
                                </Typography>
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            )}
        </div>
    );
}

export default TrackingDetailActionHeader;
